import React from 'react'
import PropTypes from 'prop-types'
import ExportOrders from "./ListCardHeaderActions/ExportOrders"
import ExportShipping from "./ListCardHeaderActions/ExportShipping"
import ExportRoyalMail from "./ListCardHeaderActions/ExportRoyalMail"
import ExportDhlTracking from "./ListCardHeaderActions/ExportDHLTracking"
import ExportQr from "./ListCardHeaderActions/ExportQR"
import ExportArx4 from "./ListCardHeaderActions/ExportARX4"
import ExportTracking from "./ListCardHeaderActions/ExportTracking"
import ImportTracking from './ListCardHeaderActions/ImportTracking'
import CombineLabels from './ListCardHeaderActions/CombineLabels'

class ListItemsCardHeader extends React.PureComponent {
    render() {
        const {filter, items, reload} = this.props

        return (
            <div className="CardHeader card-header bg-success text-white header-elements-inline">
                <h4 className='card-title'>
                    Quản trị in ấn
                </h4>
                <div className="header-elements">
                    <ExportOrders filter={filter}/>
                    <ExportShipping filter={filter}/>
                    <ExportRoyalMail filter={filter}/>
                    <ImportTracking/>
                    <ExportTracking filter={filter}/>
                    <ExportDhlTracking items={items}/>
                    <ExportQr items={items}/>
                    <ExportArx4 items={items}/>
                    <CombineLabels items={items} reload={reload}/>
                </div>
            </div>
        )
    }
}

ListItemsCardHeader.propsTypes = {
    filter: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired
}

export default ListItemsCardHeader
